module.exports = __webpack_public_path__ + "static/media/EA-Logo.da46a1e3.jpg";